import _toConsumableArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

import './folding.css';
import * as nls from '../../../nls.js';
import * as types from '../../../base/common/types.js';
import { escapeRegExpCharacters } from '../../../base/common/strings.js';
import { RunOnceScheduler, Delayer, createCancelablePromise } from '../../../base/common/async.js';
import { KeyChord } from '../../../base/common/keyCodes.js';
import { Disposable, DisposableStore } from '../../../base/common/lifecycle.js';
import { registerEditorAction, registerEditorContribution, EditorAction, registerInstantiatedEditorAction } from '../../browser/editorExtensions.js';
import { FoldingModel, setCollapseStateAtLevel, setCollapseStateLevelsDown, setCollapseStateLevelsUp, setCollapseStateForMatchingLines, setCollapseStateForType, toggleCollapseState, setCollapseStateUp } from './foldingModel.js';
import { FoldingDecorationProvider, foldingCollapsedIcon, foldingExpandedIcon } from './foldingDecorations.js';
import { EditorContextKeys } from '../../common/editorContextKeys.js';
import { HiddenRangeModel } from './hiddenRangeModel.js';
import { LanguageConfigurationRegistry } from '../../common/modes/languageConfigurationRegistry.js';
import { IndentRangeProvider } from './indentRangeProvider.js';
import { FoldingRangeProviderRegistry, FoldingRangeKind } from '../../common/modes.js';
import { SyntaxRangeProvider, ID_SYNTAX_PROVIDER } from './syntaxRangeProvider.js';
import { InitializingRangeProvider, ID_INIT_PROVIDER } from './intializingRangeProvider.js';
import { onUnexpectedError } from '../../../base/common/errors.js';
import { RawContextKey, IContextKeyService } from '../../../platform/contextkey/common/contextkey.js';
import { registerThemingParticipant } from '../../../platform/theme/common/themeService.js';
import { registerColor, editorSelectionBackground, transparent, iconForeground } from '../../../platform/theme/common/colorRegistry.js';
var CONTEXT_FOLDING_ENABLED = new RawContextKey('foldingEnabled', false);

var FoldingController = /*#__PURE__*/function (_Disposable) {
  _inherits(FoldingController, _Disposable);

  var _super = _createSuper(FoldingController);

  function FoldingController(editor, contextKeyService) {
    var _this;

    _classCallCheck(this, FoldingController);

    _this = _super.call(this);
    _this.contextKeyService = contextKeyService;
    _this.localToDispose = _this._register(new DisposableStore());
    _this.editor = editor;

    var options = _this.editor.getOptions();

    _this._isEnabled = options.get(31
    /* folding */
    );
    _this._useFoldingProviders = options.get(32
    /* foldingStrategy */
    ) !== 'indentation';
    _this._unfoldOnClickAfterEndOfLine = options.get(34
    /* unfoldOnClickAfterEndOfLine */
    );
    _this.foldingModel = null;
    _this.hiddenRangeModel = null;
    _this.rangeProvider = null;
    _this.foldingRegionPromise = null;
    _this.foldingStateMemento = null;
    _this.foldingModelPromise = null;
    _this.updateScheduler = null;
    _this.cursorChangedScheduler = null;
    _this.mouseDownInfo = null;
    _this.foldingDecorationProvider = new FoldingDecorationProvider(editor);
    _this.foldingDecorationProvider.autoHideFoldingControls = options.get(91
    /* showFoldingControls */
    ) === 'mouseover';
    _this.foldingDecorationProvider.showFoldingHighlights = options.get(33
    /* foldingHighlight */
    );
    _this.foldingEnabled = CONTEXT_FOLDING_ENABLED.bindTo(_this.contextKeyService);

    _this.foldingEnabled.set(_this._isEnabled);

    _this._register(_this.editor.onDidChangeModel(function () {
      return _this.onModelChanged();
    }));

    _this._register(_this.editor.onDidChangeConfiguration(function (e) {
      if (e.hasChanged(31
      /* folding */
      )) {
        _this._isEnabled = _this.editor.getOptions().get(31
        /* folding */
        );

        _this.foldingEnabled.set(_this._isEnabled);

        _this.onModelChanged();
      }

      if (e.hasChanged(91
      /* showFoldingControls */
      ) || e.hasChanged(33
      /* foldingHighlight */
      )) {
        var _options = _this.editor.getOptions();

        _this.foldingDecorationProvider.autoHideFoldingControls = _options.get(91
        /* showFoldingControls */
        ) === 'mouseover';
        _this.foldingDecorationProvider.showFoldingHighlights = _options.get(33
        /* foldingHighlight */
        );

        _this.onModelContentChanged();
      }

      if (e.hasChanged(32
      /* foldingStrategy */
      )) {
        _this._useFoldingProviders = _this.editor.getOptions().get(32
        /* foldingStrategy */
        ) !== 'indentation';

        _this.onFoldingStrategyChanged();
      }

      if (e.hasChanged(34
      /* unfoldOnClickAfterEndOfLine */
      )) {
        _this._unfoldOnClickAfterEndOfLine = _this.editor.getOptions().get(34
        /* unfoldOnClickAfterEndOfLine */
        );
      }
    }));

    _this.onModelChanged();

    return _this;
  }

  _createClass(FoldingController, [{
    key: "saveViewState",
    value:
    /**
     * Store view state.
     */
    function saveViewState() {
      var model = this.editor.getModel();

      if (!model || !this._isEnabled || model.isTooLargeForTokenization()) {
        return {};
      }

      if (this.foldingModel) {
        // disposed ?
        var collapsedRegions = this.foldingModel.isInitialized ? this.foldingModel.getMemento() : this.hiddenRangeModel.getMemento();
        var provider = this.rangeProvider ? this.rangeProvider.id : undefined;
        return {
          collapsedRegions: collapsedRegions,
          lineCount: model.getLineCount(),
          provider: provider
        };
      }

      return undefined;
    }
    /**
     * Restore view state.
     */

  }, {
    key: "restoreViewState",
    value: function restoreViewState(state) {
      var model = this.editor.getModel();

      if (!model || !this._isEnabled || model.isTooLargeForTokenization() || !this.hiddenRangeModel) {
        return;
      }

      if (!state || !state.collapsedRegions || state.lineCount !== model.getLineCount()) {
        return;
      }

      if (state.provider === ID_SYNTAX_PROVIDER || state.provider === ID_INIT_PROVIDER) {
        this.foldingStateMemento = state;
      }

      var collapsedRegions = state.collapsedRegions; // set the hidden ranges right away, before waiting for the folding model.

      if (this.hiddenRangeModel.applyMemento(collapsedRegions)) {
        var foldingModel = this.getFoldingModel();

        if (foldingModel) {
          foldingModel.then(function (foldingModel) {
            if (foldingModel) {
              foldingModel.applyMemento(collapsedRegions);
            }
          }).then(undefined, onUnexpectedError);
        }
      }
    }
  }, {
    key: "onModelChanged",
    value: function onModelChanged() {
      var _this2 = this;

      this.localToDispose.clear();
      var model = this.editor.getModel();

      if (!this._isEnabled || !model || model.isTooLargeForTokenization()) {
        // huge files get no view model, so they cannot support hidden areas
        return;
      }

      this.foldingModel = new FoldingModel(model, this.foldingDecorationProvider);
      this.localToDispose.add(this.foldingModel);
      this.hiddenRangeModel = new HiddenRangeModel(this.foldingModel);
      this.localToDispose.add(this.hiddenRangeModel);
      this.localToDispose.add(this.hiddenRangeModel.onDidChange(function (hr) {
        return _this2.onHiddenRangesChanges(hr);
      }));
      this.updateScheduler = new Delayer(200);
      this.cursorChangedScheduler = new RunOnceScheduler(function () {
        return _this2.revealCursor();
      }, 200);
      this.localToDispose.add(this.cursorChangedScheduler);
      this.localToDispose.add(FoldingRangeProviderRegistry.onDidChange(function () {
        return _this2.onFoldingStrategyChanged();
      }));
      this.localToDispose.add(this.editor.onDidChangeModelLanguageConfiguration(function () {
        return _this2.onFoldingStrategyChanged();
      })); // covers model language changes as well

      this.localToDispose.add(this.editor.onDidChangeModelContent(function () {
        return _this2.onModelContentChanged();
      }));
      this.localToDispose.add(this.editor.onDidChangeCursorPosition(function () {
        return _this2.onCursorPositionChanged();
      }));
      this.localToDispose.add(this.editor.onMouseDown(function (e) {
        return _this2.onEditorMouseDown(e);
      }));
      this.localToDispose.add(this.editor.onMouseUp(function (e) {
        return _this2.onEditorMouseUp(e);
      }));
      this.localToDispose.add({
        dispose: function dispose() {
          if (_this2.foldingRegionPromise) {
            _this2.foldingRegionPromise.cancel();

            _this2.foldingRegionPromise = null;
          }

          if (_this2.updateScheduler) {
            _this2.updateScheduler.cancel();
          }

          _this2.updateScheduler = null;
          _this2.foldingModel = null;
          _this2.foldingModelPromise = null;
          _this2.hiddenRangeModel = null;
          _this2.cursorChangedScheduler = null;
          _this2.foldingStateMemento = null;

          if (_this2.rangeProvider) {
            _this2.rangeProvider.dispose();
          }

          _this2.rangeProvider = null;
        }
      });
      this.onModelContentChanged();
    }
  }, {
    key: "onFoldingStrategyChanged",
    value: function onFoldingStrategyChanged() {
      if (this.rangeProvider) {
        this.rangeProvider.dispose();
      }

      this.rangeProvider = null;
      this.onModelContentChanged();
    }
  }, {
    key: "getRangeProvider",
    value: function getRangeProvider(editorModel) {
      var _this3 = this;

      if (this.rangeProvider) {
        return this.rangeProvider;
      }

      this.rangeProvider = new IndentRangeProvider(editorModel); // fallback

      if (this._useFoldingProviders && this.foldingModel) {
        var foldingProviders = FoldingRangeProviderRegistry.ordered(this.foldingModel.textModel);

        if (foldingProviders.length === 0 && this.foldingStateMemento && this.foldingStateMemento.collapsedRegions) {
          var rangeProvider = this.rangeProvider = new InitializingRangeProvider(editorModel, this.foldingStateMemento.collapsedRegions, function () {
            // if after 30 the InitializingRangeProvider is still not replaced, force a refresh
            _this3.foldingStateMemento = null;

            _this3.onFoldingStrategyChanged();
          }, 30000);
          return rangeProvider; // keep memento in case there are still no foldingProviders on the next request.
        } else if (foldingProviders.length > 0) {
          this.rangeProvider = new SyntaxRangeProvider(editorModel, foldingProviders);
        }
      }

      this.foldingStateMemento = null;
      return this.rangeProvider;
    }
  }, {
    key: "getFoldingModel",
    value: function getFoldingModel() {
      return this.foldingModelPromise;
    }
  }, {
    key: "onModelContentChanged",
    value: function onModelContentChanged() {
      var _this4 = this;

      if (this.updateScheduler) {
        if (this.foldingRegionPromise) {
          this.foldingRegionPromise.cancel();
          this.foldingRegionPromise = null;
        }

        this.foldingModelPromise = this.updateScheduler.trigger(function () {
          var foldingModel = _this4.foldingModel;

          if (!foldingModel) {
            // null if editor has been disposed, or folding turned off
            return null;
          }

          var foldingRegionPromise = _this4.foldingRegionPromise = createCancelablePromise(function (token) {
            return _this4.getRangeProvider(foldingModel.textModel).compute(token);
          });
          return foldingRegionPromise.then(function (foldingRanges) {
            if (foldingRanges && foldingRegionPromise === _this4.foldingRegionPromise) {
              // new request or cancelled in the meantime?
              // some cursors might have moved into hidden regions, make sure they are in expanded regions
              var selections = _this4.editor.getSelections();

              var selectionLineNumbers = selections ? selections.map(function (s) {
                return s.startLineNumber;
              }) : [];
              foldingModel.update(foldingRanges, selectionLineNumbers);
            }

            return foldingModel;
          });
        }).then(undefined, function (err) {
          onUnexpectedError(err);
          return null;
        });
      }
    }
  }, {
    key: "onHiddenRangesChanges",
    value: function onHiddenRangesChanges(hiddenRanges) {
      if (this.hiddenRangeModel && hiddenRanges.length) {
        var selections = this.editor.getSelections();

        if (selections) {
          if (this.hiddenRangeModel.adjustSelections(selections)) {
            this.editor.setSelections(selections);
          }
        }
      }

      this.editor.setHiddenAreas(hiddenRanges);
    }
  }, {
    key: "onCursorPositionChanged",
    value: function onCursorPositionChanged() {
      if (this.hiddenRangeModel && this.hiddenRangeModel.hasRanges()) {
        this.cursorChangedScheduler.schedule();
      }
    }
  }, {
    key: "revealCursor",
    value: function revealCursor() {
      var _this5 = this;

      var foldingModel = this.getFoldingModel();

      if (!foldingModel) {
        return;
      }

      foldingModel.then(function (foldingModel) {
        if (foldingModel) {
          var selections = _this5.editor.getSelections();

          if (selections && selections.length > 0) {
            var toToggle = [];

            var _iterator = _createForOfIteratorHelper(selections),
                _step;

            try {
              var _loop = function _loop() {
                var selection = _step.value;
                var lineNumber = selection.selectionStartLineNumber;

                if (_this5.hiddenRangeModel && _this5.hiddenRangeModel.isHidden(lineNumber)) {
                  toToggle.push.apply(toToggle, _toConsumableArray(foldingModel.getAllRegionsAtLine(lineNumber, function (r) {
                    return r.isCollapsed && lineNumber > r.startLineNumber;
                  })));
                }
              };

              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                _loop();
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }

            if (toToggle.length) {
              foldingModel.toggleCollapseState(toToggle);

              _this5.reveal(selections[0].getPosition());
            }
          }
        }
      }).then(undefined, onUnexpectedError);
    }
  }, {
    key: "onEditorMouseDown",
    value: function onEditorMouseDown(e) {
      this.mouseDownInfo = null;

      if (!this.hiddenRangeModel || !e.target || !e.target.range) {
        return;
      }

      if (!e.event.leftButton && !e.event.middleButton) {
        return;
      }

      var range = e.target.range;
      var iconClicked = false;

      switch (e.target.type) {
        case 4
        /* GUTTER_LINE_DECORATIONS */
        :
          var data = e.target.detail;
          var offsetLeftInGutter = e.target.element.offsetLeft;
          var gutterOffsetX = data.offsetX - offsetLeftInGutter; // const gutterOffsetX = data.offsetX - data.glyphMarginWidth - data.lineNumbersWidth - data.glyphMarginLeft;
          // TODO@joao TODO@alex TODO@martin this is such that we don't collide with dirty diff

          if (gutterOffsetX < 5) {
            // the whitespace between the border and the real folding icon border is 5px
            return;
          }

          iconClicked = true;
          break;

        case 7
        /* CONTENT_EMPTY */
        :
          {
            if (this._unfoldOnClickAfterEndOfLine && this.hiddenRangeModel.hasRanges()) {
              var _data = e.target.detail;

              if (!_data.isAfterLines) {
                break;
              }
            }

            return;
          }

        case 6
        /* CONTENT_TEXT */
        :
          {
            if (this.hiddenRangeModel.hasRanges()) {
              var model = this.editor.getModel();

              if (model && range.startColumn === model.getLineMaxColumn(range.startLineNumber)) {
                break;
              }
            }

            return;
          }

        default:
          return;
      }

      this.mouseDownInfo = {
        lineNumber: range.startLineNumber,
        iconClicked: iconClicked
      };
    }
  }, {
    key: "onEditorMouseUp",
    value: function onEditorMouseUp(e) {
      var _this6 = this;

      var foldingModel = this.getFoldingModel();

      if (!foldingModel || !this.mouseDownInfo || !e.target) {
        return;
      }

      var lineNumber = this.mouseDownInfo.lineNumber;
      var iconClicked = this.mouseDownInfo.iconClicked;
      var range = e.target.range;

      if (!range || range.startLineNumber !== lineNumber) {
        return;
      }

      if (iconClicked) {
        if (e.target.type !== 4
        /* GUTTER_LINE_DECORATIONS */
        ) {
          return;
        }
      } else {
        var model = this.editor.getModel();

        if (!model || range.startColumn !== model.getLineMaxColumn(lineNumber)) {
          return;
        }
      }

      foldingModel.then(function (foldingModel) {
        if (foldingModel) {
          var region = foldingModel.getRegionAtLine(lineNumber);

          if (region && region.startLineNumber === lineNumber) {
            var isCollapsed = region.isCollapsed;

            if (iconClicked || isCollapsed) {
              var toToggle = [];
              var recursive = e.event.middleButton || e.event.shiftKey;

              if (recursive) {
                var _iterator2 = _createForOfIteratorHelper(foldingModel.getRegionsInside(region)),
                    _step2;

                try {
                  for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                    var r = _step2.value;

                    if (r.isCollapsed === isCollapsed) {
                      toToggle.push(r);
                    }
                  }
                } catch (err) {
                  _iterator2.e(err);
                } finally {
                  _iterator2.f();
                }
              } // when recursive, first only collapse all children. If all are already folded or there are no children, also fold parent.


              if (isCollapsed || !recursive || toToggle.length === 0) {
                toToggle.push(region);
              }

              foldingModel.toggleCollapseState(toToggle);

              _this6.reveal({
                lineNumber: lineNumber,
                column: 1
              });
            }
          }
        }
      }).then(undefined, onUnexpectedError);
    }
  }, {
    key: "reveal",
    value: function reveal(position) {
      this.editor.revealPositionInCenterIfOutsideViewport(position, 0
      /* Smooth */
      );
    }
  }], [{
    key: "get",
    value: function get(editor) {
      return editor.getContribution(FoldingController.ID);
    }
  }]);

  return FoldingController;
}(Disposable);

FoldingController.ID = 'editor.contrib.folding';
FoldingController = __decorate([__param(1, IContextKeyService)], FoldingController);
export { FoldingController };

var FoldingAction = /*#__PURE__*/function (_EditorAction) {
  _inherits(FoldingAction, _EditorAction);

  var _super2 = _createSuper(FoldingAction);

  function FoldingAction() {
    _classCallCheck(this, FoldingAction);

    return _super2.apply(this, arguments);
  }

  _createClass(FoldingAction, [{
    key: "runEditorCommand",
    value: function runEditorCommand(accessor, editor, args) {
      var _this7 = this;

      var foldingController = FoldingController.get(editor);

      if (!foldingController) {
        return;
      }

      var foldingModelPromise = foldingController.getFoldingModel();

      if (foldingModelPromise) {
        this.reportTelemetry(accessor, editor);
        return foldingModelPromise.then(function (foldingModel) {
          if (foldingModel) {
            _this7.invoke(foldingController, foldingModel, editor, args);

            var selection = editor.getSelection();

            if (selection) {
              foldingController.reveal(selection.getStartPosition());
            }
          }
        });
      }
    }
  }, {
    key: "getSelectedLines",
    value: function getSelectedLines(editor) {
      var selections = editor.getSelections();
      return selections ? selections.map(function (s) {
        return s.startLineNumber;
      }) : [];
    }
  }, {
    key: "getLineNumbers",
    value: function getLineNumbers(args, editor) {
      if (args && args.selectionLines) {
        return args.selectionLines.map(function (l) {
          return l + 1;
        }); // to 0-bases line numbers
      }

      return this.getSelectedLines(editor);
    }
  }, {
    key: "run",
    value: function run(_accessor, _editor) {}
  }]);

  return FoldingAction;
}(EditorAction);

function foldingArgumentsConstraint(args) {
  if (!types.isUndefined(args)) {
    if (!types.isObject(args)) {
      return false;
    }

    var foldingArgs = args;

    if (!types.isUndefined(foldingArgs.levels) && !types.isNumber(foldingArgs.levels)) {
      return false;
    }

    if (!types.isUndefined(foldingArgs.direction) && !types.isString(foldingArgs.direction)) {
      return false;
    }

    if (!types.isUndefined(foldingArgs.selectionLines) && (!types.isArray(foldingArgs.selectionLines) || !foldingArgs.selectionLines.every(types.isNumber))) {
      return false;
    }
  }

  return true;
}

var UnfoldAction = /*#__PURE__*/function (_FoldingAction) {
  _inherits(UnfoldAction, _FoldingAction);

  var _super3 = _createSuper(UnfoldAction);

  function UnfoldAction() {
    _classCallCheck(this, UnfoldAction);

    return _super3.call(this, {
      id: 'editor.unfold',
      label: nls.localize('unfoldAction.label', "Unfold"),
      alias: 'Unfold',
      precondition: CONTEXT_FOLDING_ENABLED,
      kbOpts: {
        kbExpr: EditorContextKeys.editorTextFocus,
        primary: 2048
        /* CtrlCmd */
        | 1024
        /* Shift */
        | 89
        /* US_CLOSE_SQUARE_BRACKET */
        ,
        mac: {
          primary: 2048
          /* CtrlCmd */
          | 512
          /* Alt */
          | 89
          /* US_CLOSE_SQUARE_BRACKET */

        },
        weight: 100
        /* EditorContrib */

      },
      description: {
        description: 'Unfold the content in the editor',
        args: [{
          name: 'Unfold editor argument',
          description: "Property-value pairs that can be passed through this argument:\n\t\t\t\t\t\t* 'levels': Number of levels to unfold. If not set, defaults to 1.\n\t\t\t\t\t\t* 'direction': If 'up', unfold given number of levels up otherwise unfolds down.\n\t\t\t\t\t\t* 'selectionLines': The start lines (0-based) of the editor selections to apply the unfold action to. If not set, the active selection(s) will be used.\n\t\t\t\t\t\t",
          constraint: foldingArgumentsConstraint,
          schema: {
            'type': 'object',
            'properties': {
              'levels': {
                'type': 'number',
                'default': 1
              },
              'direction': {
                'type': 'string',
                'enum': ['up', 'down'],
                'default': 'down'
              },
              'selectionLines': {
                'type': 'array',
                'items': {
                  'type': 'number'
                }
              }
            }
          }
        }]
      }
    });
  }

  _createClass(UnfoldAction, [{
    key: "invoke",
    value: function invoke(_foldingController, foldingModel, editor, args) {
      var levels = args && args.levels || 1;
      var lineNumbers = this.getLineNumbers(args, editor);

      if (args && args.direction === 'up') {
        setCollapseStateLevelsUp(foldingModel, false, levels, lineNumbers);
      } else {
        setCollapseStateLevelsDown(foldingModel, false, levels, lineNumbers);
      }
    }
  }]);

  return UnfoldAction;
}(FoldingAction);

var UnFoldRecursivelyAction = /*#__PURE__*/function (_FoldingAction2) {
  _inherits(UnFoldRecursivelyAction, _FoldingAction2);

  var _super4 = _createSuper(UnFoldRecursivelyAction);

  function UnFoldRecursivelyAction() {
    _classCallCheck(this, UnFoldRecursivelyAction);

    return _super4.call(this, {
      id: 'editor.unfoldRecursively',
      label: nls.localize('unFoldRecursivelyAction.label', "Unfold Recursively"),
      alias: 'Unfold Recursively',
      precondition: CONTEXT_FOLDING_ENABLED,
      kbOpts: {
        kbExpr: EditorContextKeys.editorTextFocus,
        primary: KeyChord(2048
        /* CtrlCmd */
        | 41
        /* KEY_K */
        , 2048
        /* CtrlCmd */
        | 89
        /* US_CLOSE_SQUARE_BRACKET */
        ),
        weight: 100
        /* EditorContrib */

      }
    });
  }

  _createClass(UnFoldRecursivelyAction, [{
    key: "invoke",
    value: function invoke(_foldingController, foldingModel, editor, _args) {
      setCollapseStateLevelsDown(foldingModel, false, Number.MAX_VALUE, this.getSelectedLines(editor));
    }
  }]);

  return UnFoldRecursivelyAction;
}(FoldingAction);

var FoldAction = /*#__PURE__*/function (_FoldingAction3) {
  _inherits(FoldAction, _FoldingAction3);

  var _super5 = _createSuper(FoldAction);

  function FoldAction() {
    _classCallCheck(this, FoldAction);

    return _super5.call(this, {
      id: 'editor.fold',
      label: nls.localize('foldAction.label', "Fold"),
      alias: 'Fold',
      precondition: CONTEXT_FOLDING_ENABLED,
      kbOpts: {
        kbExpr: EditorContextKeys.editorTextFocus,
        primary: 2048
        /* CtrlCmd */
        | 1024
        /* Shift */
        | 87
        /* US_OPEN_SQUARE_BRACKET */
        ,
        mac: {
          primary: 2048
          /* CtrlCmd */
          | 512
          /* Alt */
          | 87
          /* US_OPEN_SQUARE_BRACKET */

        },
        weight: 100
        /* EditorContrib */

      },
      description: {
        description: 'Fold the content in the editor',
        args: [{
          name: 'Fold editor argument',
          description: "Property-value pairs that can be passed through this argument:\n\t\t\t\t\t\t\t* 'levels': Number of levels to fold.\n\t\t\t\t\t\t\t* 'direction': If 'up', folds given number of levels up otherwise folds down.\n\t\t\t\t\t\t\t* 'selectionLines': The start lines (0-based) of the editor selections to apply the fold action to. If not set, the active selection(s) will be used.\n\t\t\t\t\t\t\tIf no levels or direction is set, folds the region at the locations or if already collapsed, the first uncollapsed parent instead.\n\t\t\t\t\t\t",
          constraint: foldingArgumentsConstraint,
          schema: {
            'type': 'object',
            'properties': {
              'levels': {
                'type': 'number'
              },
              'direction': {
                'type': 'string',
                'enum': ['up', 'down']
              },
              'selectionLines': {
                'type': 'array',
                'items': {
                  'type': 'number'
                }
              }
            }
          }
        }]
      }
    });
  }

  _createClass(FoldAction, [{
    key: "invoke",
    value: function invoke(_foldingController, foldingModel, editor, args) {
      var lineNumbers = this.getLineNumbers(args, editor);
      var levels = args && args.levels;
      var direction = args && args.direction;

      if (typeof levels !== 'number' && typeof direction !== 'string') {
        // fold the region at the location or if already collapsed, the first uncollapsed parent instead.
        setCollapseStateUp(foldingModel, true, lineNumbers);
      } else {
        if (direction === 'up') {
          setCollapseStateLevelsUp(foldingModel, true, levels || 1, lineNumbers);
        } else {
          setCollapseStateLevelsDown(foldingModel, true, levels || 1, lineNumbers);
        }
      }
    }
  }]);

  return FoldAction;
}(FoldingAction);

var ToggleFoldAction = /*#__PURE__*/function (_FoldingAction4) {
  _inherits(ToggleFoldAction, _FoldingAction4);

  var _super6 = _createSuper(ToggleFoldAction);

  function ToggleFoldAction() {
    _classCallCheck(this, ToggleFoldAction);

    return _super6.call(this, {
      id: 'editor.toggleFold',
      label: nls.localize('toggleFoldAction.label', "Toggle Fold"),
      alias: 'Toggle Fold',
      precondition: CONTEXT_FOLDING_ENABLED,
      kbOpts: {
        kbExpr: EditorContextKeys.editorTextFocus,
        primary: KeyChord(2048
        /* CtrlCmd */
        | 41
        /* KEY_K */
        , 2048
        /* CtrlCmd */
        | 42
        /* KEY_L */
        ),
        weight: 100
        /* EditorContrib */

      }
    });
  }

  _createClass(ToggleFoldAction, [{
    key: "invoke",
    value: function invoke(_foldingController, foldingModel, editor) {
      var selectedLines = this.getSelectedLines(editor);
      toggleCollapseState(foldingModel, 1, selectedLines);
    }
  }]);

  return ToggleFoldAction;
}(FoldingAction);

var FoldRecursivelyAction = /*#__PURE__*/function (_FoldingAction5) {
  _inherits(FoldRecursivelyAction, _FoldingAction5);

  var _super7 = _createSuper(FoldRecursivelyAction);

  function FoldRecursivelyAction() {
    _classCallCheck(this, FoldRecursivelyAction);

    return _super7.call(this, {
      id: 'editor.foldRecursively',
      label: nls.localize('foldRecursivelyAction.label', "Fold Recursively"),
      alias: 'Fold Recursively',
      precondition: CONTEXT_FOLDING_ENABLED,
      kbOpts: {
        kbExpr: EditorContextKeys.editorTextFocus,
        primary: KeyChord(2048
        /* CtrlCmd */
        | 41
        /* KEY_K */
        , 2048
        /* CtrlCmd */
        | 87
        /* US_OPEN_SQUARE_BRACKET */
        ),
        weight: 100
        /* EditorContrib */

      }
    });
  }

  _createClass(FoldRecursivelyAction, [{
    key: "invoke",
    value: function invoke(_foldingController, foldingModel, editor) {
      var selectedLines = this.getSelectedLines(editor);
      setCollapseStateLevelsDown(foldingModel, true, Number.MAX_VALUE, selectedLines);
    }
  }]);

  return FoldRecursivelyAction;
}(FoldingAction);

var FoldAllBlockCommentsAction = /*#__PURE__*/function (_FoldingAction6) {
  _inherits(FoldAllBlockCommentsAction, _FoldingAction6);

  var _super8 = _createSuper(FoldAllBlockCommentsAction);

  function FoldAllBlockCommentsAction() {
    _classCallCheck(this, FoldAllBlockCommentsAction);

    return _super8.call(this, {
      id: 'editor.foldAllBlockComments',
      label: nls.localize('foldAllBlockComments.label', "Fold All Block Comments"),
      alias: 'Fold All Block Comments',
      precondition: CONTEXT_FOLDING_ENABLED,
      kbOpts: {
        kbExpr: EditorContextKeys.editorTextFocus,
        primary: KeyChord(2048
        /* CtrlCmd */
        | 41
        /* KEY_K */
        , 2048
        /* CtrlCmd */
        | 85
        /* US_SLASH */
        ),
        weight: 100
        /* EditorContrib */

      }
    });
  }

  _createClass(FoldAllBlockCommentsAction, [{
    key: "invoke",
    value: function invoke(_foldingController, foldingModel, editor) {
      if (foldingModel.regions.hasTypes()) {
        setCollapseStateForType(foldingModel, FoldingRangeKind.Comment.value, true);
      } else {
        var editorModel = editor.getModel();

        if (!editorModel) {
          return;
        }

        var comments = LanguageConfigurationRegistry.getComments(editorModel.getLanguageIdentifier().id);

        if (comments && comments.blockCommentStartToken) {
          var regExp = new RegExp('^\\s*' + escapeRegExpCharacters(comments.blockCommentStartToken));
          setCollapseStateForMatchingLines(foldingModel, regExp, true);
        }
      }
    }
  }]);

  return FoldAllBlockCommentsAction;
}(FoldingAction);

var FoldAllRegionsAction = /*#__PURE__*/function (_FoldingAction7) {
  _inherits(FoldAllRegionsAction, _FoldingAction7);

  var _super9 = _createSuper(FoldAllRegionsAction);

  function FoldAllRegionsAction() {
    _classCallCheck(this, FoldAllRegionsAction);

    return _super9.call(this, {
      id: 'editor.foldAllMarkerRegions',
      label: nls.localize('foldAllMarkerRegions.label', "Fold All Regions"),
      alias: 'Fold All Regions',
      precondition: CONTEXT_FOLDING_ENABLED,
      kbOpts: {
        kbExpr: EditorContextKeys.editorTextFocus,
        primary: KeyChord(2048
        /* CtrlCmd */
        | 41
        /* KEY_K */
        , 2048
        /* CtrlCmd */
        | 29
        /* KEY_8 */
        ),
        weight: 100
        /* EditorContrib */

      }
    });
  }

  _createClass(FoldAllRegionsAction, [{
    key: "invoke",
    value: function invoke(_foldingController, foldingModel, editor) {
      if (foldingModel.regions.hasTypes()) {
        setCollapseStateForType(foldingModel, FoldingRangeKind.Region.value, true);
      } else {
        var editorModel = editor.getModel();

        if (!editorModel) {
          return;
        }

        var foldingRules = LanguageConfigurationRegistry.getFoldingRules(editorModel.getLanguageIdentifier().id);

        if (foldingRules && foldingRules.markers && foldingRules.markers.start) {
          var regExp = new RegExp(foldingRules.markers.start);
          setCollapseStateForMatchingLines(foldingModel, regExp, true);
        }
      }
    }
  }]);

  return FoldAllRegionsAction;
}(FoldingAction);

var UnfoldAllRegionsAction = /*#__PURE__*/function (_FoldingAction8) {
  _inherits(UnfoldAllRegionsAction, _FoldingAction8);

  var _super10 = _createSuper(UnfoldAllRegionsAction);

  function UnfoldAllRegionsAction() {
    _classCallCheck(this, UnfoldAllRegionsAction);

    return _super10.call(this, {
      id: 'editor.unfoldAllMarkerRegions',
      label: nls.localize('unfoldAllMarkerRegions.label', "Unfold All Regions"),
      alias: 'Unfold All Regions',
      precondition: CONTEXT_FOLDING_ENABLED,
      kbOpts: {
        kbExpr: EditorContextKeys.editorTextFocus,
        primary: KeyChord(2048
        /* CtrlCmd */
        | 41
        /* KEY_K */
        , 2048
        /* CtrlCmd */
        | 30
        /* KEY_9 */
        ),
        weight: 100
        /* EditorContrib */

      }
    });
  }

  _createClass(UnfoldAllRegionsAction, [{
    key: "invoke",
    value: function invoke(_foldingController, foldingModel, editor) {
      if (foldingModel.regions.hasTypes()) {
        setCollapseStateForType(foldingModel, FoldingRangeKind.Region.value, false);
      } else {
        var editorModel = editor.getModel();

        if (!editorModel) {
          return;
        }

        var foldingRules = LanguageConfigurationRegistry.getFoldingRules(editorModel.getLanguageIdentifier().id);

        if (foldingRules && foldingRules.markers && foldingRules.markers.start) {
          var regExp = new RegExp(foldingRules.markers.start);
          setCollapseStateForMatchingLines(foldingModel, regExp, false);
        }
      }
    }
  }]);

  return UnfoldAllRegionsAction;
}(FoldingAction);

var FoldAllAction = /*#__PURE__*/function (_FoldingAction9) {
  _inherits(FoldAllAction, _FoldingAction9);

  var _super11 = _createSuper(FoldAllAction);

  function FoldAllAction() {
    _classCallCheck(this, FoldAllAction);

    return _super11.call(this, {
      id: 'editor.foldAll',
      label: nls.localize('foldAllAction.label', "Fold All"),
      alias: 'Fold All',
      precondition: CONTEXT_FOLDING_ENABLED,
      kbOpts: {
        kbExpr: EditorContextKeys.editorTextFocus,
        primary: KeyChord(2048
        /* CtrlCmd */
        | 41
        /* KEY_K */
        , 2048
        /* CtrlCmd */
        | 21
        /* KEY_0 */
        ),
        weight: 100
        /* EditorContrib */

      }
    });
  }

  _createClass(FoldAllAction, [{
    key: "invoke",
    value: function invoke(_foldingController, foldingModel, _editor) {
      setCollapseStateLevelsDown(foldingModel, true);
    }
  }]);

  return FoldAllAction;
}(FoldingAction);

var UnfoldAllAction = /*#__PURE__*/function (_FoldingAction10) {
  _inherits(UnfoldAllAction, _FoldingAction10);

  var _super12 = _createSuper(UnfoldAllAction);

  function UnfoldAllAction() {
    _classCallCheck(this, UnfoldAllAction);

    return _super12.call(this, {
      id: 'editor.unfoldAll',
      label: nls.localize('unfoldAllAction.label', "Unfold All"),
      alias: 'Unfold All',
      precondition: CONTEXT_FOLDING_ENABLED,
      kbOpts: {
        kbExpr: EditorContextKeys.editorTextFocus,
        primary: KeyChord(2048
        /* CtrlCmd */
        | 41
        /* KEY_K */
        , 2048
        /* CtrlCmd */
        | 40
        /* KEY_J */
        ),
        weight: 100
        /* EditorContrib */

      }
    });
  }

  _createClass(UnfoldAllAction, [{
    key: "invoke",
    value: function invoke(_foldingController, foldingModel, _editor) {
      setCollapseStateLevelsDown(foldingModel, false);
    }
  }]);

  return UnfoldAllAction;
}(FoldingAction);

var FoldLevelAction = /*#__PURE__*/function (_FoldingAction11) {
  _inherits(FoldLevelAction, _FoldingAction11);

  var _super13 = _createSuper(FoldLevelAction);

  function FoldLevelAction() {
    _classCallCheck(this, FoldLevelAction);

    return _super13.apply(this, arguments);
  }

  _createClass(FoldLevelAction, [{
    key: "getFoldingLevel",
    value: function getFoldingLevel() {
      return parseInt(this.id.substr(FoldLevelAction.ID_PREFIX.length));
    }
  }, {
    key: "invoke",
    value: function invoke(_foldingController, foldingModel, editor) {
      setCollapseStateAtLevel(foldingModel, this.getFoldingLevel(), true, this.getSelectedLines(editor));
    }
  }]);

  return FoldLevelAction;
}(FoldingAction);

FoldLevelAction.ID_PREFIX = 'editor.foldLevel';

FoldLevelAction.ID = function (level) {
  return FoldLevelAction.ID_PREFIX + level;
};

registerEditorContribution(FoldingController.ID, FoldingController);
registerEditorAction(UnfoldAction);
registerEditorAction(UnFoldRecursivelyAction);
registerEditorAction(FoldAction);
registerEditorAction(FoldRecursivelyAction);
registerEditorAction(FoldAllAction);
registerEditorAction(UnfoldAllAction);
registerEditorAction(FoldAllBlockCommentsAction);
registerEditorAction(FoldAllRegionsAction);
registerEditorAction(UnfoldAllRegionsAction);
registerEditorAction(ToggleFoldAction);

for (var i = 1; i <= 7; i++) {
  registerInstantiatedEditorAction(new FoldLevelAction({
    id: FoldLevelAction.ID(i),
    label: nls.localize('foldLevelAction.label', "Fold Level {0}", i),
    alias: "Fold Level ".concat(i),
    precondition: CONTEXT_FOLDING_ENABLED,
    kbOpts: {
      kbExpr: EditorContextKeys.editorTextFocus,
      primary: KeyChord(2048
      /* CtrlCmd */
      | 41
      /* KEY_K */
      , 2048
      /* CtrlCmd */
      | 21
      /* KEY_0 */
      + i),
      weight: 100
      /* EditorContrib */

    }
  }));
}

export var foldBackgroundBackground = registerColor('editor.foldBackground', {
  light: transparent(editorSelectionBackground, 0.3),
  dark: transparent(editorSelectionBackground, 0.3),
  hc: null
}, nls.localize('foldBackgroundBackground', "Background color behind folded ranges. The color must not be opaque so as not to hide underlying decorations."), true);
export var editorFoldForeground = registerColor('editorGutter.foldingControlForeground', {
  dark: iconForeground,
  light: iconForeground,
  hc: iconForeground
}, nls.localize('editorGutter.foldingControlForeground', 'Color of the folding control in the editor gutter.'));
registerThemingParticipant(function (theme, collector) {
  var foldBackground = theme.getColor(foldBackgroundBackground);

  if (foldBackground) {
    collector.addRule(".monaco-editor .folded-background { background-color: ".concat(foldBackground, "; }"));
  }

  var editorFoldColor = theme.getColor(editorFoldForeground);

  if (editorFoldColor) {
    collector.addRule("\n\t\t.monaco-editor .cldr".concat(foldingExpandedIcon.cssSelector, ",\n\t\t.monaco-editor .cldr").concat(foldingCollapsedIcon.cssSelector, " {\n\t\t\tcolor: ").concat(editorFoldColor, " !important;\n\t\t}\n\t\t"));
  }
});